'use strict';

import { COOKIE_NAMES } from './cookieManager.service';

export default function NavPathWithToggleValueFilter($window, cookieManager) {
  'ngInject';

  const COOKIE_NAME = COOKIE_NAMES.HOME_NAV_TOGGLE_STATE;
  const cookieManger = cookieManager;

  return function (path) {
    let toggledValue = cookieManger.getCookie(COOKIE_NAME) || 'cards';
    path = path.replace('cards', toggledValue);

    return path;
  };
}
